<template>
  <div class="content">
    <div
      style="
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 100px;
      "
    >
      <div class="title">手机号登录</div>
      <div>
        <div>
          <div class="title tit1">账号</div>
          <input v-model="phone" type="text" placeholder="请输入手机号" />
        </div>
        <div style="position: relative">
          <div class="title tit1">密码</div>
          <input
            id="input"
            v-model="password"
            type="password"
            placeholder="请输入密码"
          />
          <van-icon name="closed-eye" v-if="!showPwd" @click="showPassword" />
          <van-icon name="eye-o" v-else @click="showPassword" />
        </div>
        <button class="btn" v-if="!show" @click="login">登录</button>
        <button
          class="btn"
          style="background-color: #397bffad"
          v-else
          :disabled="true"
        >
          登录中...
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/addressBook";
import { Toast } from "vant";
export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      phone: "",
      password: "",
      show: false,
      showPwd: false,
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    showPassword() {
      // 获取输入框dom
      let inp = document.getElementById("input");
      // 判断当前输入框类型是为文本框还是密码框
      if (inp.type == "password") {
        inp.type = "text";
        this.showPwd = true;
      } else if ((inp.type = "text")) {
        inp.type = "password";
        this.showPwd = false;
      }
    },
    login() {
      if (!this.phone) {
        Toast("请输入手机号");
        return;
      }
      if (!this.password) {
        Toast("请输入密码");
        return;
      }
      this.show = true;
      getUserInfo({
        Mobile: this.phone,
        LoginPwd: this.password,
      }).then((res) => {
        if (res.data.code == 0) {
          Toast.success("登录成功");
          this.show = false;
          setTimeout(() => {
            this.gotoUrl("/addressBookList");
            // this.$router.push("/addressBookList");
          }, 1000);
        } else {
          Toast(res.data.msg);
          this.show = false;
        }
      });
    },
    // 跳转
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../list/index?path=" + path,
        });
      } else {
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        this.$router.push(path);
      }
    },
  },
  created() {},
  mounted() {},
};
</script> 

<style scoped >
.content {
  background-image: url(https://points-malls.oss-cn-beijing.aliyuncs.com/goodsImg/1608.png);
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.title {
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 21px;
  color: #1f1f1f;
}

.tit1 {
  font-size: 17px;
  margin-top: 40px;
}

input {
  border: none;
  border-bottom: 1px solid #eeeeee;
  margin-top: 20px;
  width: 100%;
  /* width: 319px; */
}

.btn {
  background: #397aff;
  border-radius: 24px;
  border: none;
  padding: 0;
  /* width: 130%; */
  width: 319px;
  height: 47px;
  line-height: 47px;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  margin-top: 40px;
}

/deep/ .van-icon {
  position: absolute;
  right: 0;
  bottom: 4px;
}
</style>